import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Box, Button } from '../../../../common/components';
import { Form, Row, Col } from 'react-bootstrap';
import SelectMenu from '../../../../common/components/SelectMenu/SelectMenu';
import { compose } from 'redux';

const FORM_NAME = 'BrokerAdminFeeForm';

const BrokerAdminFeeForm = ({ handleSubmit, submitting, onUpdateFee }) => {
  return (
    <Box>
      <Form onSubmit={handleSubmit(onUpdateFee)}>
        <Row>
          <Col sm={12}>
            <h4 className="page-title">Admin Fee</h4>
          </Col>
        </Row>
        <Row>
          <Col sm={2}>
            <Field
              name={'data.attributes.admin_fee_tier'}
              component={SelectMenu}
              optionValuePath={'attributes.name'}
              source={'brokers/admin-fees'}
            />
          </Col>
          <Col xs={2}>
            <Button
              className="pull-right"
              type="submit"
              bsStyle="primary"
              label={'Update Admin Fee'}
              isLoading={submitting}
            />
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

export default compose(
  connect((state, props) => {
    return {
      initialValues: props.resource,
    };
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(BrokerAdminFeeForm);
